import { EditableCampaign, WebSettings } from "@/interfaces";
import { CampaignServices, CampaignStatsResponse, SmartLinkServices } from "@/services/bedrock";
import * as React from "react";
import { useEffect } from "react";

import PostsStats from "../../../../../components/PostsStats";
import { SmartLinkAggregatedStatsDialog } from "@/containers/Coach/SmartLink/StatsDialog/SmartLinkAggregatedStatsDialog";
import { useAccountSettings } from "@/utils";

interface CampaignStatsProps {
  campaign: EditableCampaign | undefined;
}

type Props = CampaignStatsProps;

const CampaignStats: React.FC<Props> = ({ campaign }) => {
  const [stats, setStats] = React.useState<CampaignStatsResponse>();
  const [loading, setLoading] = React.useState<boolean>(false);
  const { hasAccountSetting } = useAccountSettings();
  const hasSmartLinks = hasAccountSetting(WebSettings.LINK_TRACKING);

  const [totalClicks, setTotalClicks] = React.useState<number>();
  const [loadingClickStats, setLoadingClickStats] = React.useState<boolean>(false);
  const [showSmartLinkStats, setShowSmartLinkStats] = React.useState<boolean>(false);

  const requestClickStats = async () => {
    const campaignId = campaign?.campaignId;
    if (campaignId) {
      setLoadingClickStats(true);
      const data = await SmartLinkServices.getSmartLinkStatsByCampaign(campaignId, ["total_clicks"]);
      setTotalClicks(data.totalClicks || 0);
    }
  };

  useEffect(() => {
    requestStats().catch(console.error);
  }, [campaign]);

  useEffect(() => {
    if (campaign && hasSmartLinks) {
      requestClickStats().catch(console.error);
    }
  }, [campaign, hasSmartLinks]);

  const requestStats = async () => {
    const campaignId = campaign?.campaignId;
    if (campaignId) {
      setLoading(true);
      const stats = await CampaignServices.getCampaignStats(campaignId);
      setStats(stats);
    }
    setLoading(false);
  };

  useEffect(() => {
    requestStats().catch(console.error);
  }, [campaign]);

  return campaign ? (
    <>
      <PostsStats
        stats={stats}
        smartLinkClicks={totalClicks}
        showSmartLinkStats={() => setShowSmartLinkStats(true)}
        type={"Campaign"}
        loading={loading}
      />
      {showSmartLinkStats && (
        <SmartLinkAggregatedStatsDialog
          open={showSmartLinkStats}
          onOpenChange={setShowSmartLinkStats}
          type={"Campaign"}
          entity={campaign}
        />
      )}
    </>
  ) : undefined;
};

export default CampaignStats;
